// JS mirror of the colors in scss/_variables.scss for inline styles / Ant props.
// Prefer SCSS classes; use these only where a style prop is unavoidable.
export const COLORS = {
  primaryText: '#4B5054',
  productText: '#383E42',
  secondaryText: '#93959B',
  defaultSecondary: '#797C81',
  baseGrey: '#C9CACD',
  borderLight: '#E9E9EA',
  borderMedium: '#DCDCDC',
  bgSubtle: '#F5F5F5',
  link: '#3984DA',
  info: '#227AE5',
  error: '#CC2626',
  warning: '#EF8943',
} as const;
